import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import {
  BehaviorSubject,
  combineLatest,
  EMPTY,
  merge,
  of,
  Subject,
} from "rxjs";
import { filter, map, switchMap, take, takeUntil, tap } from "rxjs/operators";
import { DialogImage } from "src/app/data/dialog-image";
import { DialogService } from "src/service/dialog.service";
import { UserService } from "src/service/user.service";
import { MyPackageService } from "../../saving-plans/my-package.service";
import { SavingPlansService } from "../../saving-plans/saving-plans.service";
import { CheckoutService } from "../checkout.service";
import {AddressService} from '../../../../service/address.service';

@Component({
  selector: "app-select-shipment",
  templateUrl: "./select-shipment.component.html",
  styleUrls: ["../../dashboard.style.scss"],
})
export class SelectShipmentComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public checkoutService: CheckoutService,
    public addressService: AddressService,
    private dialogService: DialogService,
    private myPackageService: MyPackageService,
    private userService: UserService,
    private savingPlanService: SavingPlansService
  ) {}

  type;
  shippingPrice = of(0);
  basketTax = of(0);
  basketCost = new BehaviorSubject(0);
  totalPrice;
  vaultSubsCost = new BehaviorSubject(0);
  shipmentForm: FormGroup;
  $destroy = new Subject();

  shipmentMap = [
    {
      value: "PICKUP",
      routerLink: "map",
    },
    {
      value: "SHIPMENT",
      routerLink: "cargo",
    },
    {
      value: "VAULT",
      routerLink: "payment",
    },
  ];

  checkRedirectionToPayment() {
    if (this.checkoutService.goingBack) {
      this.router.navigate(["../../"], { relativeTo: this.route });
      this.checkoutService.goingBack = false;
      return true;
    }
    this.type = this.route.snapshot.queryParams["type"];
    if (
      this.type != null &&
      this.checkoutService.redirectToPaymentList.includes(this.type)
    ) {
      const { getBasketCost } =
        this.checkoutService.selectedPaymentRequest.value;

      getBasketCost().subscribe((totalPrice) => {
        this.checkoutService.totalPrice.next(totalPrice);
        this.router.navigate(["..", "payment"], { relativeTo: this.route });
      });
      return true;
    }
    return false;
  }

  ngOnInit(): void {
    this.addressService.getCountryListForCargo().subscribe(list => {
      if (list.find(c => c.englishName.toLowerCase() === this.userService.user.value.country.toLowerCase())) {
        this.checkoutService.refreshCheckout({country: this.userService.user.value.country});
      }
    });
    const { getShipmentCost, getBasketCost, getTaxPrice } =
      this.checkoutService.selectedPaymentRequest.value;

    this.shipmentForm = new FormGroup({
      shipment: new FormControl("PICKUP"),
    });
    if (this.checkRedirectionToPayment()) return;
    merge(
      of("PICKUP"),
      this.shipmentForm.get("shipment").valueChanges
    ).subscribe((afterPurchaseType) => {
      this.checkoutService.selectedShipment = afterPurchaseType;
      if (!this.checkoutService.redirectToPaymentList.includes(this.type)) {
        this.shippingPrice = getShipmentCost(afterPurchaseType);
        this.basketTax = getTaxPrice(afterPurchaseType);
      }

      if (afterPurchaseType == "VAULT" || afterPurchaseType == "PICKUP") {
        this.shippingPrice = of(0).pipe(
          tap((shippingPrice) =>
            this.checkoutService.shippingPrice.next(shippingPrice)
          )
        );
      }

      this.totalPrice = combineLatest([
        getBasketCost(),
        this.shippingPrice,
        this.basketTax,
        this.checkoutService.getVaultSubscriptionCost(),
      ]).pipe(
        tap(([basketCost, shippingPrice, basketTax, vaultSubsCost]: any) => {
          this.basketCost.next(basketCost);
          this.vaultSubsCost.next(vaultSubsCost);
        }),
        map(
          ([productPrice, shippingPrice, basketTax, vaultSubsCost]: any) =>
            productPrice + shippingPrice + vaultSubsCost
        ),
        tap((totalPrice) => this.checkoutService.totalPrice.next(totalPrice))
      );
    });
  }

  sellFinishedSavingPlan() {
    this.dialogService
      .showYesNoDialog("ARE_YOU_SURE_TO_SELL")
      .pipe(
        switchMap((yes) => {
          if (yes) {
            return this.myPackageService
              .sellFinishedSavingPlan(
                this.myPackageService.selectedMyPackage.value.id
              )
              .pipe(
                switchMap(() =>
                  this.dialogService.showSuccessDialog(
                    "VAULT_SELL_SUCCESS_EURO",
                    DialogImage.MONEY_TRANSFERRED
                  )
                ),
                switchMap(() =>
                  this.savingPlanService.refreshSavingPlansWithoutTakeUntil()
                )
              );
          } else {
            return EMPTY;
          }
        })
      )

      .subscribe(
        () => {
          this.myPackageService.selectedMyPackage.next(null);
          this.router.navigate(["/saving-plans"]);
        },
        (error) => this.dialogService.showErrorDialog(error)
      );
  }

  onSubmit() {
    const shipment = this.shipmentForm.value.shipment;

/*     if (
      shipment == "SHIPMENT" &&
      !this.checkoutService.germanyTranslates.includes(
        this.userService.user.value.country
      )
    ) {
      this.dialogService.showErrorDialog("NEED_COUNTRY_ADDRESS_GERMANY");
      return;
    } */

    this.checkoutService.refreshCheckout({
      afterPurchaseType: shipment,
      country: this.userService.user.value.country,
    });
    const link = this.shipmentMap.find(
      (item) => item.value == shipment
    ).routerLink;
    this.router.navigate(["..", link], { relativeTo: this.route });
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }
}
